/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { PostApiBookingTablet201, PostApiBookingTablet400, PostApiBookingTablet403, PostApiBookingTablet404, PostApiBookingTablet500, PostApiBookingTabletMutationRequest, PostApiBookingTabletMutationResponse, PostApiBookingTabletQueryParams } from "../entities/PostApiBookingTablet";
import { modelsErrorResponseSchema } from "./models/errorResponseSchema";
import { modelsTabletBookingInputSchema } from "./models/tabletBookingInputSchema";
import { modelsTabletBookingOutputSchema } from "./models/tabletBookingOutputSchema";
import { z } from "zod/v4";

export const postApiBookingTabletQueryParamsSchema = z.object({
    "branch_id": z.coerce.number().int().min(1).describe("ID филиала")
    }) as unknown as z.ZodType<PostApiBookingTabletQueryParams>

/**
 * @description Created
 */
export const postApiBookingTablet201Schema = z.lazy(() => modelsTabletBookingOutputSchema) as unknown as z.ZodType<PostApiBookingTablet201>

/**
 * @description Bad Request
 */
export const postApiBookingTablet400Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBookingTablet400>

/**
 * @description Forbidden
 */
export const postApiBookingTablet403Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBookingTablet403>

/**
 * @description Not Found
 */
export const postApiBookingTablet404Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBookingTablet404>

/**
 * @description Internal Server Error
 */
export const postApiBookingTablet500Schema = z.lazy(() => modelsErrorResponseSchema).describe("Standard error response") as unknown as z.ZodType<PostApiBookingTablet500>

/**
 * @description Данные записи с планшета
 */
export const postApiBookingTabletMutationRequestSchema = z.lazy(() => modelsTabletBookingInputSchema) as unknown as z.ZodType<PostApiBookingTabletMutationRequest>

export const postApiBookingTabletMutationResponseSchema = z.lazy(() => postApiBookingTablet201Schema) as unknown as z.ZodType<PostApiBookingTabletMutationResponse>